import CurrentOrders from "../components/currentOrders";
export default function Orders() {
  return (
    <div>
      <CurrentOrders />
    </div>
  );
}
